import { render } from "./FaktureSve.vue?vue&type=template&id=0c4aabc6&scoped=true&lang=html"
import script from "./FaktureSve.vue?vue&type=script&lang=js"
export * from "./FaktureSve.vue?vue&type=script&lang=js"

import "./FaktureSve.vue?vue&type=style&index=0&id=0c4aabc6&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0c4aabc6"

export default script